import { postMessageToIframeParent } from "./iframeMessaging.ts";

export const iframeDetailRedirect = (id: number) => {
  postMessageToIframeParent({ type: "redirect", id: id });
};
